<div class="page-header">
  <h2 class="mat-h2">Leagues</h2>
  <button mat-flat-button color="primary" type="button" (click)="createLeague()">
    <mat-icon>add</mat-icon>
    Create league
  </button>
</div>

<mat-table [dataSource]="leagues$ | async">
  <ng-container matColumnDef="id">
    <mat-header-cell *matHeaderCellDef> id</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.id }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="name">
    <mat-header-cell *matHeaderCellDef> name</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.name }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="federation">
    <mat-header-cell *matHeaderCellDef> federation</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.federation }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="poweredBy">
    <mat-header-cell *matHeaderCellDef> poweredBy</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.poweredBy }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="licenced">
    <mat-header-cell *matHeaderCellDef> licenced</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.licenced }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="archived">
    <mat-header-cell *matHeaderCellDef> archived</mat-header-cell>
    <mat-cell *matCellDef="let row"> {{ row.archived }}</mat-cell>
  </ng-container>
  <ng-container matColumnDef="actions">
    <mat-header-cell *matHeaderCellDef> Actions</mat-header-cell>
    <mat-cell *matCellDef="let row">
      <button mat-stroked-button type="button" [routerLink]="'/admin/league/' + row.id">Update</button>
      <button mat-stroked-button type="button" *ngIf="!row.archived" (click)="archiveLeague(row.id, true)">Archive</button>
      <button mat-stroked-button type="button" *ngIf="row.archived" (click)="archiveLeague(row.id, false)">Restore</button>
      <button mat-stroked-button type="button" (click)="deleteLeague(row.id)">Delete</button>
    </mat-cell>
  </ng-container>
  <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: columns"></mat-row>
</mat-table>
